(function (angular) {


  angular
    .module("app")
    .factory("pcmtidLoginService", ["$http", "$window","UserProvider","$q","alk.authentication.config","alkAuthenticationService", function ($http, $window,UserProvider,$q,config,alkAuthenticationService) {
      function tidlogin(authCode,account,redirectUrl) {
        var deferred = $q.defer();

        const loginRequest = {
          method: "POST",
          url: `${config.ssoUrl}v1/trimbleid/authenticate`,
          data: {
            authorizationCode: authCode,
            redirectUrl:redirectUrl,
            applicationName: config.applicationName,
            account: account,
            trimbleApplication:getTidApplicationName()
          },
          withCredentials: true
        };

        $http(loginRequest)
          .then(res => {
            const { data } = res;
            if (data.userId && data.authToken) {
              window.localStorage.removeItem("logoutInProgress");
              $window.sessionStorage["trimbleIdToken"] = data.idToken;
              if (config.applicationUrl) {
                const { authToken, username, accountName, forcePasswordReset } = data;
                alkAuthenticationService.getUserInfo(authToken, username, accountName, forcePasswordReset)
                  .then(userInfo => {
                    UserProvider.loadUser(userInfo.user);

                    deferred.resolve(userInfo.user);
                  }, (err) => {
                    console.log("rejected user info", err);
                    deferred.reject(err);
                  });
              } else {
                UserProvider.loadUser(data);
                deferred.resolve(data);
              }
            } else {
              deferred.reject(data);
            }
          }, (err) => {
            deferred.reject(err.data);
          });

        return deferred.promise;

      }
      function baseUrl() {
        return  `${`${window.location.protocol  }//${  window.location.host}`}`;
      }
      function getClientId() {

        return config.clientId;
      }
      function getTidApplicationName() {

        return config.tidApplicationName;
      }
      function getTrimbleCloudUrl() {

        return config.trimbleCloudUrl;
      }
      function logOutOfTrimbleIdentity(token) {
        var redirectUrl = `${baseUrl()}/tid/logout`;
        var url = `${getTrimbleCloudUrl()}oauth/logout?`;
        url += `&id_token_hint=${token}`;
        url += `&post_logout_redirect_uri=${redirectUrl}`;
        window.location.href = url;
      }
      function checkTidEmail(username) {
        var deferred = $q.defer();

        const migrationRequest = {
          method: "POST",
          url: `${config.ssoUrl}v1/trimbleid/migration-status`,
          data: {
            "email": username
          },

        };

        $http(migrationRequest)
          .then(res => {
            console.log(res.data);
            deferred.resolve(res.data);
          }, (err) => {
            deferred.reject(err.data);
          });
        return deferred.promise;
      }
      function goToTidSignin(user,redirectUrl,ssoUser) {

        const username = encodeURIComponent(user);
        var url = `${getTrimbleCloudUrl()}oauth/authorize?response_type=code&scope=openid ${getTidApplicationName()}`;
        url += `&client_id=${getClientId()}`;
        url += `&redirect_uri=${redirectUrl}&state=${username}&prompt=login&login_hint=${username}&ssoUser=${ssoUser}`;
        return url;
      }
      function goToTidSignup(user,redirectUrl,ssoUser) {
        const username = encodeURIComponent(user);
        var url = `${getTrimbleCloudUrl()}oauth/authorize?response_type=code&scope=openid ${getTidApplicationName()}`;
        url += `&client_id=${getClientId()}`;
        url += `&redirect_uri=${redirectUrl}&state=${username}&prompt=create&login_hint=${username}&ssoUser=${ssoUser}`;

        return url;
      }
      return {
        tidlogin:tidlogin,
        baseUrl:baseUrl,
        getClientId:getClientId,
        getTidApplicationName:getTidApplicationName,
        getTrimbleCloudUrl:getTrimbleCloudUrl,
        logOutOfTrimbleIdentity:logOutOfTrimbleIdentity,
        checkTidEmail:checkTidEmail,
        goToTidSignin:goToTidSignin,
        goToTidSignup:goToTidSignup
      };
    }]);
})(angular);



// WEBPACK FOOTER //
// ./app/account/pcmtidLogin.service.js